import { useEffect, useState } from 'react';

import { useMutationCreateSuggestion } from '@hooks/index';
import { Status } from '@interfaces/apiInterface';
import { SuggestionCreateDto } from '@interfaces/suggestionInterface';
import { Role } from '@interfaces/userInterface';
import { Button } from 'antd';
import { RefreshCcw } from 'react-feather';
import { ScheduleReplaceModal } from './Modal/ScheduleReplaceModal';
import { useToast } from '../../Toast/ToastProvider';

type ScheduleReplaceProps = {
	role: Role;
	scheduleId: number;
	userSuggester: number;
};

const ScheduleReplace = ({ role: assignmentRole, scheduleId, userSuggester }: ScheduleReplaceProps) => {
	const { showError, showSuccess } = useToast();
	const [open, setOpen] = useState(false);

	const {
		mutate: mutateCreateSuggestion,
		status: statusCreateSuggestions,
		isPending: isLoadingCreateSuggestions
	} = useMutationCreateSuggestion();

	const onSubmitHandler = async (values: unknown) => {
		mutateCreateSuggestion(values as SuggestionCreateDto);
	};

	useEffect(() => {
		if (statusCreateSuggestions === Status.Error) {
			showError({
				title: 'Erreur',
				description: 'Une erreur est survenue, veuillez réessayer plus tard.'
			});
		}

		if (statusCreateSuggestions === Status.Success) {
			showSuccess({
				title: 'Succès',
				description: 'Votre demande de remplacement a été correctement envoyée.'
			});
			setOpen(false);
		}
	}, [statusCreateSuggestions, showError, showSuccess]);

	return (
		<>
			<Button
				className="my-1"
				size="small"
				icon={<RefreshCcw className="mr-2" size={14} />}
				onClick={() => setOpen(true)}
			>
				Remplacement
			</Button>
			{open && (
				<ScheduleReplaceModal
					userSuggester={userSuggester}
					scheduleId={scheduleId}
					role={assignmentRole}
					setOpen={setOpen}
					loading={isLoadingCreateSuggestions}
					open={open}
					onSubmit={onSubmitHandler}
				/>
			)}
		</>
	);
};

export default ScheduleReplace;
